/*
 * gr-cart.js — Mutaciones de carrito compartidas entre el panel "cart" de gr-variant-drawer y
 * gr-cart-page. Toda mutación pide re-render vía Section Rendering (sections=gr-variant-drawer,
 * gr-cart-page) y parchea SOLO el innerHTML del contenedor marcado con [data-gr-cart-refresh],
 * nunca el nodo raíz — mismo patrón "root nunca cambia" ya probado en el cart drawer del tema
 * anterior (evita perder listeners delegados).
 *
 * Interacciones de línea (cantidad, quitar, editar) van por delegación de eventos en `document`,
 * así que sobreviven a que gr-cart.js reemplace el HTML de las líneas sin tener que re-inicializar
 * nada. gr-cart-discount SÍ necesita reinit explícito (window.grReinitDiscount) porque su <script>
 * no se re-ejecuta al parchear innerHTML.
 */
window.GrCart = (function () {
  function mutate(url, body) {
    var config = fetchConfig('json');
    config.body = JSON.stringify(
      Object.assign(
        {
          sections: 'gr-variant-drawer,gr-cart-page',
          sections_url: window.location.pathname,
        },
        body
      )
    );
    return fetch(url, config).then(function (r) {
      return r.json().then(function (data) {
        return { ok: r.ok, data: data };
      });
    });
  }

  function changeQuantity(key, quantity) {
    return mutate(window.routes.cart_change_url, { id: key, quantity: quantity }).then(applyResponse);
  }

  function addItems(items) {
    return mutate(window.routes.cart_add_url, { items: items }).then(applyResponse);
  }

  function applyResponse(res) {
    var data = res.data;
    if (data && data.sections) {
      patchSection(data.sections['gr-variant-drawer'], 'drawer');
      patchSection(data.sections['gr-cart-page'], 'page');
    }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gr-cart', cartData: data });
    }
    document.dispatchEvent(new CustomEvent('gr:cartUpdated', { detail: { res: res } }));
    return res;
  }

  function patchSection(html, marker) {
    if (!html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('[data-gr-cart-refresh="' + marker + '"]');
    var live = document.querySelector('[data-gr-cart-refresh="' + marker + '"]');
    if (!fresh || !live) return;
    live.innerHTML = fresh.innerHTML;
    if (window.grReinitDiscount) window.grReinitDiscount(live);
  }

  /* ---------- Delegación de eventos: cantidad / quitar / editar por línea ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-gr-cline-qty-minus]');
    var plus = e.target.closest('[data-gr-cline-qty-plus]');
    var removeBtn = e.target.closest('[data-gr-cline-remove]');
    var editBtn = e.target.closest('[data-gr-cline-edit]');

    if (minus || plus) {
      var line = (minus || plus).closest('[data-gr-cline]');
      if (!line) return;
      var valueEl = line.querySelector('[data-gr-cline-qty-value]');
      var current = parseInt((valueEl && valueEl.textContent) || '1', 10) || 1;
      var next = minus ? Math.max(0, current - 1) : current + 1;
      line.classList.add('is-updating');
      changeQuantity(line.dataset.key, next);
      return;
    }

    if (removeBtn) {
      var lineToRemove = removeBtn.closest('[data-gr-cline]');
      if (!lineToRemove) return;
      lineToRemove.classList.add('is-updating');
      changeQuantity(lineToRemove.dataset.key, 0);
      return;
    }

    if (editBtn) {
      document.dispatchEvent(
        new CustomEvent('gr:openCartLineEditor', {
          detail: {
            handle: editBtn.dataset.handle,
            variantId: editBtn.dataset.variantId,
            key: editBtn.dataset.key,
            quantity: editBtn.dataset.quantity,
          },
        })
      );
    }
  });

  return { mutate: mutate, changeQuantity: changeQuantity, addItems: addItems, applyResponse: applyResponse };
})();
